import { jsx } from "react/jsx-runtime";
import PolylineIcon from "@mui/icons-material/Polyline";
import { validateTidalLicense } from "../../base/index.js";
function Polyline(props) {
  return /* @__PURE__ */ jsx(
    PolylineIcon,
    {
      "data-testid": "Polyline",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Polyline",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Polyline.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Polyline"
};
validateTidalLicense();
export {
  Polyline
};
//# sourceMappingURL=Polyline.js.map
